module.exports = __webpack_public_path__ + "bnbproject/img/bakerySwap.274d69d1.jpg";